import { useState } from "react";

export function useAgeValidation(minAge = 18) {
  const [ageError, setAgeError] = useState("");

  const validateAge = (ageStr) => {
    if (!/^\d*$/.test(ageStr)) {
      setAgeError("Age must be a number");
      return false;
    }

    const age = parseInt(ageStr, 10);
    if (isNaN(age)) {
      setAgeError("Please enter your age");
      return false;
    }

    if (age < minAge) {
      setAgeError("Individuals under 18 must have parent or guardian consent to receive therapy.");
      return false;
    }

    setAgeError("");
    return true;
  };

  return { ageError, validateAge };
}
